// organizations.js

import values from "lodash/values";
import { createSelector } from "reselect";

import { entityFactory } from "./entity";

const fetchActionCreator = type => {
  return id => {
    return {
      type,
      id,
    };
  };
};

const urlCreator = action => `/v1/organizations`;

const { reducer, watcher, fetcher } = entityFactory(
  "organizations",
  fetchActionCreator,
  urlCreator
);

export default reducer;
export const organizationWatcher = watcher;
export const fetchOrganizations = fetcher;

// selectors
const getOrganizationsById = state => state.entities.organizations.byId;
export const getSelectedOrganizationId = (_, props) =>
  Number(props.match.params.organization);

export const getOrganizations = createSelector(
  [getOrganizationsById],
  orgsByName => values(orgsByName)
);

export const getSelectedOrganization = createSelector(
  [getOrganizationsById, getSelectedOrganizationId],
  (orgsById, selectedOrgId) => {
    return orgsById[selectedOrgId];
  }
);

export const getSelectedOrganizationName = createSelector(
  [getOrganizationsById, getSelectedOrganizationId],
  (orgsById, selectedOrganizationId) => {
    return (
      orgsById[selectedOrganizationId] &&
      orgsById[selectedOrganizationId].displayName
    );
  }
);
